module.exports = __webpack_public_path__ + "121faa6ae783c298e4b98527d22bd74b.png";